import api from "../api";
let noopTimer = null;
export default {
  //页面埋点
  pagePoint(p) {
    let dataTrackingParams = localStorage.getItem("dataTrackingParams");
    let data = {};
    data = { ...JSON.parse(dataTrackingParams) }; //页面埋点需要传的参数
    console.log(data);

    //页面销毁埋点
    if (!p) {
      // 记录离开页面时间
      data.leave_time = Date.now();
      // 记录浏览时长
      // 将时间戳转换为Date对象
      let date1 = new Date(data.join_time);
      let date2 = new Date(data.leave_time);
      // 获取两个日期之间的时间间隔（毫秒）
      const timeDifference = Math.abs(date2 - date1);
      // 转化为s，得到浏览时长
      data.duration = Math.floor(timeDifference / 1000);

      localStorage.removeItem("dataTrackingParams");
      // 若该页面已经无操作埋点，离开该页面不需要再次进行埋点
      if (localStorage.getItem("noOperationFlag")) {
        localStorage.removeItem("noOperationFlag");
        return;
      }
    }

    //无操作埋点
    if (p == "no-operation") {
      data.leave_time = data.join_time + 60000; //离开时间
      data.duration = 60;
    }

    //埋点
    let params = {};
    if (data.scene) {
      localStorage.setItem("SCENE", data.scene);
    }
    if (data.keyword) {
      localStorage.setItem("search", data.keyword);
    }

    params.web_url = data.web_url || ""; //当前路由
    params.type = data.type || ""; //// 1 主页数据，2专题页，3活动，4组件点击事件
    params.scene = localStorage.getItem("SCENE") || "";
    params.user_id = "";
    params.mch_id = data.mch_id || ""; // 商户
    params.order_type = data.order_type || "";
    params.order_id = data.order_id || "";
    params.goods_id = data.goods_id || "";
    params.goods_type = data.goods_type || ""; //商品类型
    params.cat_id = data.cat_id || ""; //分类id
    params.brand_id = data.brand_id || ""; // 品牌id
    params.keyword = localStorage.getItem("search") || ""; // 搜索关键词
    params.is_keyword = data.is_keyword || "";
    params.source_url = data.source_url || "";
    params.is_keyword_result = data.is_keyword_result || "";
    params.is_order = data.is_order || 0;
    params.is_cart = data.is_cart || 0;
    params.is_login = data.is_login || 0;
    params.jointime = data.join_time || "";
    params.leavetime = data.leave_time || "";
    params.duration = data.duration || 0;

    api.statistics_data(params).then((res) => {
      console.log(res);
    });
  },
  // 清除无操作埋点计时器
  clearNoopTimer() {
    if (noopTimer) {
      clearInterval(noopTimer);
    }
  },
  // 开始无操作埋点计时器
  startNoopTimer() {
    // 该页面已进行过无操作埋点，再次触发重新记录开始时间
    if (localStorage.getItem("noOperationFlag")) {
      let dataTrackingParams = localStorage.getItem("dataTrackingParams");
      let data = { ...JSON.parse(dataTrackingParams) };
      data.join_time = Date.now();
      localStorage.setItem("dataTrackingParams", JSON.stringify(data));
      localStorage.removeItem("noOperationFlag");
    }
    let info = localStorage.getItem("dataTrackingParams");
    let copy_info = { ...JSON.parse(info) };
    let end_ime = new Date(copy_info.join_time + 60000).toString();
    if (noopTimer) {
      clearInterval(noopTimer);
      noopTimer = null;
    }
    noopTimer = setInterval(() => {
      console.log(end_ime, `无操作埋点计时器`, new Date().toString());
      if (new Date().toString() == end_ime) {
        this.pagePoint("no-operation");
        clearInterval(noopTimer);
        // 无操作埋点标识
        localStorage.setItem("noOperationFlag", true);
        return;
      }
    }, 1000);
  },
};
